const toArray = (value) => (Array.isArray(value) ? value : []);

const isPartyCombatant = (combatant = {}) => combatant.type === 'player' || combatant.type === 'npc';

export const buildEnemyKilledTriggerContext = (triggerCtx = {}) => ({
  ...triggerCtx,
  killedEnemies: triggerCtx.name ? [triggerCtx.name] : [],
});

export const resolveEnemyKilledSideEffects = ({
  triggerCtx = {},
  combatants = [],
  chars = {},
  systems = null,
  journal = [],
  npcLibrary = {},
  processRules = null,
  applyRuleResults = null,
  applyNpcUpdates = null,
} = {}) => {
  const triggerContext = buildEnemyKilledTriggerContext(triggerCtx);
  const worldContext = { chars, journal, npcLibrary };

  const result = {
    triggerContext,
    worldContext,
    nextChars: chars,
    charsChanged: false,
    nextNpcLibrary: npcLibrary,
    npcLibraryChanged: false,
    notifications: [],
    pendingNpcUpdates: [],
    processedCharIds: [],
  };

  if (!systems || !chars || typeof processRules !== 'function' || typeof applyRuleResults !== 'function') {
    return result;
  }

  const nextChars = { ...chars };

  toArray(combatants).forEach((party) => {
    if (!isPartyCombatant(party)) return;

    const partyChar = chars[party.id];
    if (!partyChar || !toArray(partyChar.systemList).length) return;

    const ruleResults = processRules('on-enemy-killed', partyChar, systems, triggerContext, worldContext) || {};
    const ruleUpdates = applyRuleResults(partyChar, ruleResults, systems, worldContext) || {};

    result.processedCharIds.push(party.id);

    if (Object.keys(ruleUpdates).length > 0) {
      nextChars[party.id] = { ...partyChar, ...ruleUpdates };
      result.charsChanged = true;
    }

    if (ruleResults.notifications?.length) {
      result.notifications.push(...ruleResults.notifications.map((message) => `${party.name}: ${message}`));
    }

    if (ruleResults.pendingNpcUpdates?.length) {
      result.pendingNpcUpdates.push(...ruleResults.pendingNpcUpdates);
    }
  });

  if (result.charsChanged) {
    result.nextChars = nextChars;
  }

  if (result.pendingNpcUpdates.length > 0 && typeof applyNpcUpdates === 'function') {
    const npcResult = applyNpcUpdates(npcLibrary, result.pendingNpcUpdates) || {};
    result.nextNpcLibrary = npcResult.nextLibrary || npcLibrary;
    result.npcLibraryChanged = npcResult.changed === true;
  }

  return result;
};
